var klaviyo = klaviyo || [];
klaviyo.init({
  account: "QdgNFy",
  platform: "shopify"
});
klaviyo.enable("backinstock",{ 
  trigger: {
    product_page_text: "Notifícame cuando esté disponible",
    product_page_class: "customer-account-button",
    product_page_text_align: "center",
    product_page_margin: "12px auto 0",
    replace_anchor: false
  },
  modal: {
  headline: "{product_name}",
  body_content: "¡Anótate a la lista y te llegará un correo en cuanto volvamos a tener este producto disponible!",
  email_field_label: "Correo electrónico",
  button_label: "Anotarme",
  subscription_success_label: "Te avisaremos cuando esté de vuelta.",
  footer_content: '',
  additional_styles: "@import url(//www.tropicalheal.com/cdn/shop/t/76/assets/klaviyo-back-in-stock.css?v=80426279551068406691744651799)",
  drop_background_color: "#000",
  background_color: "#fff",
  text_color: "#000",
  button_text_color: "#fff",
  button_background_color: "#439fdb",
  close_button_color: "#ccc",
  error_background_color: "#fff8f8",
  error_text_color: "#d20000",
  success_background_color: "#F8FFF9",
  success_text_color: "#1F873D"
  }
});